// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__manropeFont_717784', '__manropeFont_Fallback_717784', system-ui, arial"},"className":"__className_717784"};